/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { INodeProps, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
//import classnames from 'classnames';

import { IProductCollectionViewProps, IProductComponentViewProps } from './list-product-collection';

import { clsHelper } from '../../utilities/class-name-helper';

//==========================================================
// CLASS NAME UTILITY
//==========================================================
const BASE_CLASS = 'list-product-collection';
const cls = (fragment?: string) => clsHelper(BASE_CLASS, fragment);
//==========================================================

const ProductCollectionView: React.FC<IProductCollectionViewProps> = props => {
    const {
        heading,
        ProductCollectionContainer,
        products,
        SingleSlideCarouselComponentProps,
        GridComponentProps,
        isCarousel,
    } = props;

    const currentProducts = Array.isArray(products) ? products : [];

    if (currentProducts) {
        return (
            <Module {...ProductCollectionContainer}>
                {heading}
                {isCarousel ? _renderCarousel(SingleSlideCarouselComponentProps, currentProducts) : _renderGrid(GridComponentProps, currentProducts, props)}
            </Module>
        );
    }
    props.context.telemetry.error('Product collection content is empty, module wont render.');
    return null;
};

const _renderCarousel = (carouselContainer: INodeProps, items: IProductComponentViewProps[]): JSX.Element => {
    return <Node {...carouselContainer}>{items && items.map(currentItem => _renderProduct(currentItem))}</Node>;
};

const _renderGrid = (gridContainer: INodeProps, items: IProductComponentViewProps[], props: IProductCollectionViewProps): JSX.Element => {
    return (
        <div className={cls('items-container')}>
            <Node {...gridContainer}>
                {_renderTableHeading(props)}
                {items && items.map(currentItem => _renderProduct(currentItem))}
            </Node>
        </div>
    );
};


const _renderProduct = (product: IProductComponentViewProps): JSX.Element => {
    const { ProductContainer, productComponent } = product;
    return <Node {...ProductContainer}>{productComponent}</Node>;
};

// @CUSTOM: Items table heading row
const _renderTableHeading = (props: IProductCollectionViewProps): JSX.Element => {
    const { resources } = props;
    const clsHeading = (fragment?: string) => clsHelper(cls('item-heading')!, fragment, '-');

    return (
        <li className={clsHeading()}>
            <div className={clsHeading('image')} />
            <div className={clsHeading('number')}>{resources.listProductCollection_numberLabel}</div>
            <div className={clsHeading('name')}>{resources.listProductCollection_nameLabel}</div>
            <div className={clsHeading('price')}>{resources.listProductCollection_priceLabel}</div>
            <div className={clsHeading('availability')}>{resources.listProductCollection_availabilityLabel}</div>
            <div className={clsHeading('quantity')}>{resources.listProductCollection_quantityLabel}</div>
            <div className={clsHeading('actions')} />
        </li>
    );
};

export default ProductCollectionView;
